"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * English localization
 */
exports.default = {
    /**
     * Welcome page
     */
    skip: 'Skip',
    letsStart: "Let's Start",
    next: 'Next',
    registerNow: 'Register now',
    welcome_title_1: 'Discover the first NFT based wallet',
    welcome_subtitle_1: 'Buy, collect and trade items',
    welcome_title_2: 'Create your own NFT collection now',
    welcome_subtitle_2: 'Buy, collect and trade items',
    welcome_title_3: 'Discover the exciting world of crypto',
    welcome_subtitle_3: 'Buy, collect and trade items',
    /**
     * Login and registration page
     */
    login: 'Login',
    welcomeBack: "Welcome back, we've missed you!",
    noAccount: "Don't have an account?",
    register: 'Register',
    offline: 'You seem offline!',
    checkConnection: 'Check connection and try again',
    username: 'Username',
    usernameOrEmail: 'Username or Email',
    usernameRequired: 'Username is required *',
    password: 'Password',
    passwordErrorLength: 'Must be at least 8 characters',
    forgotPassword: 'Forgot Password?',
    byClickingRegister: 'By clicking “Register” you agree to our',
    privacyNotice: 'Privacy Notice',
    termsAndConditions: 'Terms and Conditions.',
    and: 'and',
    accountRemoved: 'Account Removed',
    accountRemovedMessage: 'Your account was successfully removed.',
    /**
     * Reset Password page
     */
    resetPassword: 'Reset Password',
    currentPassword: 'Current password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm new password',
    emailSent: 'Email successfully sent!',
    passwordChanged: 'Password changed',
    passwordUpdated: 'Your password has been updated successfully.',
    incorrectPassword: 'Incorrect password',
    passwordDoesNotMatch: 'Password does not match. Please try again.',
    close: 'Close',
    emailSentTo: 'Email is sent to',
    withLinkTo: 'with a link to reset your password.',
    reset: 'Reset',
    passwordResetEmailSent: 'We have sent instructions to reset password to your email',
    passwordResetEmailNotSent: 'We could not send instructions to reset password',
    resetPasswordNote: 'Note: If we find the account associated with the mail, you will receive a code to complete your password reset.',
    backTo: 'Back to',
    resetPasswordRules: 'Your password must include at least 8 characters and should include a combination of letters, numbers and special characters.',
    /**
     * Enrollment page
     */
    wallet: 'Wallet',
    walletActivationFail: 'Wallet activation failed.',
    walletActivationFailMessage: 'Something went wrong. Please try again later.',
    walletImportSuccess: 'Wallet Imported Successfully',
    walletImportSuccessMsg: 'Your wallet has been imported successfully.',
    walletNotActivated: 'Wallet not activated, try again',
    important: 'Important!',
    walletInfo: 'Your wallet has been activated. Please backup your wallet and store it securely.',
    ok: 'Ok',
    finish: 'Finish',
    activationSuccessful: 'Activation successful',
    importCertificate: 'Import Certificate',
    activate: 'Activate',
    reactivate: 'Reactivate',
    activateYourWallet: 'Activate your wallet',
    reactivateYourWallet: 'Reactivate your wallet',
    import: 'Import',
    walletImportFail: 'Wallet import failed',
    tryWalletImportAgain: 'Please check the file you selected to import and try again.',
    yourWalletActivated: 'Your wallet has been activated successfully.',
    youWalletActivatedDescription: "Please keep your wallet secure. Don't share it with others as this represents your blockchain identity. We advise you to backup your wallet in case you lose or switch your device.",
    activateWalletDescription: 'To access your tickets you have to activate your wallet first. Activating your wallet issues a certificate that proves your ownership of the ticket.',
    reactivateWalletDescription: 'To access your tickets you have to reactivate your wallet first. Reactivating your wallet issues a certificate that proves your ownership of the ticket.',
    beSureToBackUp: 'Be sure to backup your wallet after activation.',
    beSureToReBackUp: 'Be sure to backup your wallet after reactivation.',
    youAlreadyActivatedWallet: 'You already activated your wallet. To access your tickets you will need to import your certificate.',
    importWalletAccessTickets: 'Import your wallet in order to access all purchased tickets',
    almostDoneImportingWallet: 'You are almost done! Importing your wallet',
    almostDoneActivatingWallet: 'You are almost done! Activating your wallet',
    almostDoneReactivatingWallet: 'You are almost done! Reactivating your wallet',
    didNotBackUpWallet: "If you didn't backup your certificate, or you lost your phone, contact support @BAMSupport.",
    /**
     * Menu
     */
    myProfile: 'My Profile',
    save: 'Save',
    organizer: 'Organizer',
    signout: 'Sign Out',
    signoutTitle: 'Are you sure you want to Sign Out?',
    signoutMessage: 'Make sure you saved all the changes you made before you sign out.',
    applicationSettings: 'Application Settings',
    support: 'Support',
    /**
     * Profile page
     */
    account: 'Account',
    personalInformation: 'Personal Information',
    informationUpdated: 'Information updated successfully!',
    invalidEmail: 'Valid email address is required',
    chooseOption: 'Choose an option',
    cancel: 'Cancel',
    galleryImages: 'Gallery Images',
    profilePicture: 'Profile Picture',
    imageNotUploaded: 'Image not uploaded!',
    useCamera: 'Use Camera',
    removeAccountError: 'Could not remove account, try again.',
    removeAccountSure: 'Are you sure you want to remove your account?',
    removeAccountInfo: 'By removing your account, you will lose all  tickets you currently own.',
    removeAccount: 'Remove account',
    personalData: 'PERSONAL DATA',
    atLeastThreeCharacters: 'At least 3 charaters long',
    firstname: 'First Name',
    lastname: 'Last Name',
    email: 'Email',
    dateOfBirthday: 'Date of Birth (Optional)',
    phone: 'Phone (Optional)',
    address: 'Address',
    city: 'City',
    state: 'State',
    country: 'Country',
    location: 'LOCATION',
    paypalAccount: 'Paypal Account',
    /**
     * Organizer publish page
     */
    transaction: 'Transaction',
    transactionPublished: 'Transaction published successfully',
    transactionNotPublished: 'Unable to publish transaction',
    transactionProcessing: 'Transaction is currently processing, please wait!',
    /**
     * Register page
     */
    invalidPassword: 'Password must have at least 8 characters including at least one lowercase, one uppercase letter and one number.',
    invalidUsername: 'Usernames must be at least 3 characters long and can contain Latin alphabet uppercase and lowercase letters, numbers, dashes and underscores',
    letsGetOnBoard: "Let's get you on board!",
    enterValidUsername: 'Enter valid username *',
    enterValidFirstname: 'Enter valid first name *',
    enterValidLastname: 'Enter valid last name *',
    enterValidEmail: 'Enter valid email *',
    alreadyHaveAccount: 'Already have an account?',
    /**
     * Tickets overview page
     */
    start: 'Start',
    seating: 'Seating',
    date: 'date',
    edit: 'Edit',
    ticketInvalidated: 'This ticket has already been scanned and used.',
    dateOfSale: 'Date of Sale',
    price: 'Price',
    expirationDate: 'Expiration Date',
    removeFromMarketPlace: 'Remove from Marketplace',
    activateConfirmTitle: 'Are you sure want to activate this ticket?',
    activateConfirmText: "Once activated, you'll not be able to deactivate nor transfer or sell it.",
    activateTicket: 'Activate Ticket',
    ticketIsProcessed: 'Your ticket is still being processed - once it is issued you can transfer, sell & activate it.',
    moreInfo: 'More info',
    swipeEventDetails: 'Swipe for event details',
    /**
     * Single Ticket screen
     */
    qrCode: 'QR code',
    ticketCantActivate: 'The ticket QR code remains locked until seven days before the event.',
    ticketActivateFirst: 'To show the QR code, the ticket must first be activated.',
    ticketCantActivateEnded: "You can't activate the ticket after the event has passed.",
    showQrCodeAtEntrance: 'Show the QR code at the entrance to access the event.',
    options: 'Options',
    transferTicketsToFriends: 'Transfer tickets to your friends at no cost or sell them on our secure secondary marketplace',
    ticket: 'Ticket',
    discount: 'Discount',
    dateAndLocation: 'Date & Location',
    ticketHolder: 'Ticket Holder',
    ticketDetails: 'Ticket details',
    readMore: 'Read more',
    eventDetails: 'Event details',
    buyTickets: 'Buy tickets',
    detailsAboutTicket: 'Details about the ticket',
    detailsAboutEvent: 'Details about this event',
    /**
     * Form input component
     */
    gender: 'Gender (Optional)',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    /**
     * Wallet page
     */
    exportShareMessage: 'Save your wallet on a secure space:',
    backupWallet: 'Backup Wallet',
    backup: 'Backup',
    backupText: 'You did not backup your wallet yet, please create a backup in case you need to recover your wallet.',
    backupIncomplete: 'Backup incomplete',
    backupComplete: 'Backup completed',
    backupSuccessTitle: 'Your wallet has been backed up successfully.',
    backupSuccessInfo: 'Please keep your wallet secure. Don’t share it with others as this represents your blockchain identity. ',
    permissionDenied: 'Permission denied, Try again',
    shareMessage: "Let's share some tickets! Here is my ",
    copied: 'Copied',
    add: 'Add',
    connectedWallets: 'Connected Wallets',
    connectYourWallet: 'Connect your wallet',
    connectYourWalletInfo: "If you don't have a wallet yet, you can select a provider, download the app, and create one now.",
    metamask: 'Metamask',
    to: 'to',
    the: 'the',
    downloads: 'Downloads',
    folder: 'folder',
    /**
     * Offline page
     */
    offlineHeader: 'Offline',
    offlineText: 'You are currently offline.',
    offlineSecondText: 'Certain functions may not be available.',
    /**
     * Home page
     */
    tickets: 'Tickets',
    pastExperience: 'Past Experiences',
    upcoming: 'Upcoming',
    noTickets: "You don't have any tickets yet.",
    checkOutOur: 'Check out our ',
    ticketMarketplace: 'Ticket Marketplace',
    toGetThem: ' to get them.',
    /**
     * Transfer page
     */
    transferTicket: 'Transfer Tickets',
    transferTicketDescription: 'Scan a QR-Code or enter the recipients Wallet-ID in order to select and transfer tickets.',
    bamWalletShareTitleStart: "Your friend doesn't have the ",
    bamWalletShareTitleEnd: ' App yet? ',
    bamWalletShareSubTitleStart: 'Invite your friends and share the ',
    bamWalletShareSubTitleEnd: ' with them to ensure easy tickets transfer.',
    enterWalletId: 'Recipient Wallet-ID',
    walletIdError: 'User not found / Incomplete ID',
    share: 'Share',
    transfer: 'Transfer',
    sell: 'Sell',
    sellTicket: 'Sell Ticket',
    walletId: 'Wallet-ID',
    transferModalSbtitle: 'Once transferred, tickets will be removed from your Wallet.',
    shareModalTitleStart: 'Share ',
    shareModalTitleEnd: ' with a friend',
    succesTransferMessageTile: 'Ticket(s) transferred',
    errorTransferMessageTile: 'Ticket(s) transfer failed',
    succesTransferMessage: 'Your ticket(s) have been transferred succefully. They are no longer available in your wallet.',
    errorTransferMessage: 'Something went wrong. Please try again later.',
    done: 'Done',
    areYouSureTransfer: 'Are you sure you want to transfer',
    ticketsTo: 'ticket(s) to',
    tryAgain: 'Try again',
    findUser: 'Find User',
    emailOrWalletId: 'Email or Wallet-ID',
    emailDoesNotExist: 'We cannot find a user with this email. Check the email or press "Invite" to invite user and transfer tickets.',
    invite: 'Invite',
    selectTicketsToTransfer: 'Select tickets to transfer to: ',
    transferring: 'Transferring ',
    transferringTickets: ' ticket(s).',
    okay: 'Okay',
    sureCancelTransferTo: 'Are you sure you want to cancel the transfer to ',
    ifYouCancelNowRepeatLater: 'If you cancel the transfer process now, you can repeat it later.',
    cancelTransfer: 'Cancel Transfer',
    backToTickets: 'Back to tickets',
    successSentInvite: 'You have successfully sent an invite to a user.',
    ableToTransferTicketsNow: 'You will be able to transfer ticket(s) to the user now.',
    /**
     * Qrcode Scanner
     */
    qrcodeScannerScreenTitle: 'Scan Wallet',
    scanWallet: 'Scan Wallet',
    /**
     * Ticket holder information
     */
    cancelSureTitle: 'Are you sure you want to cancel?',
    cancelSureText: 'Make sure you saved all changes before you exit the process.',
    confirm: 'Confirm',
    /**
     * Sell ticket
     */
    sellTickets: 'Sell Tickets',
    setExpiration: 'Set Expiration Date',
    ticketPrice: 'Ticket price',
    sellTicketConfirmTitle: 'Are you sure you want to sell your ticket on Secondary Marketplace?',
    sellTicketConfirmMessage: 'You will be able to access ticket(s) from your wallet and cancel the sell.',
    succesSellTile: 'Ticket(s) published on Marketplace',
    succesSellMessage: 'Your ticket(s) have been successfully published on Secondary Marketplace.',
    errorSellTitle: 'Failed to publish ticket on Marketplace',
    errorSellMessage: 'An error occurred while trying to publish your ticket on sale. Please try again. ',
    sellFeeHintStart: 'Organizer takes a',
    sellFeeHintMiddle: '% fee on the sale for this event. You will receive',
    sellNoFeeHint: 'Organizer takes no fees on the sale for this event. You will receive',
    setExpirationDate: 'Set Expiration Date',
    payout: 'Payout',
    payoutHintText1: 'Please provide a PayPal account or an email address that should be used for the payout.',
    payoutHintText2: 'Payments happen automatically through PayPal once your ticket is sold. You will receive an email notification after the sale is processed.',
    payoutHintText3: 'Thank you for using our platform! If you have any questions, reach out to our Support Team.',
    publishingTicketToSecondaryMarket: 'Publishing your ticket(s) on Secondary Marketplace.',
    /**
     * Bottom menu
     */
    nft: 'nft',
    profile: 'Profile',
    /**
     * NFT screen
     */
    myCollection: 'My Collection',
    noNFTsYet: 'No NFTs yet',
    doNotSeeNFT: "Don't see your NFT?",
    importNFTs: 'Import NFTs',
    description: 'Description',
    chain: 'Chain',
    /**
     * Metamask wallets screen
     */
    selectWallet: 'Select Wallet',
    connectedAddresses: 'Connected Addresses',
    confirmRemoveWalletTitle: 'Are you sure you want to remove this address?',
    confirmRemoveWalletText: 'If you remove this address, all of your connected NFTs will be removed.',
    removeAddress: 'Remove Address',
    /**
     * Metamask add component
     */
    metamaskWalletConnectSuccessTitle: 'Metamask wallet connected.',
    metamaskWalletConnectSuccessText: 'Your Metamask wallet has been added successfully.',
    metamaskWalletConnectErrorTitle: 'Metamask wallet error.',
    metamaskWalletConnectErrorText: 'Unable to add wallet from metamask.',
    /**
     * App screen
     */
    applicationUpdateTitle: 'Application update required.',
    applicationUpdateText: 'A new version of the application is available and is required to continue. Please click below to update to the latest version.',
    update: 'Update',
    understand: 'I understand',
    /**
     * Settings
     */
    settings: 'Settings',
    notifications: 'Notifications',
    enableNotifications: 'Enable notifications',
    eventStart: 'Event start',
    checkIn: 'Check-In',
    none: 'None',
    minutes: 'minutes',
    hour: 'hour',
    fiveMinutesBefore: '5 minutes before',
    tenMinutesBefore: '10 minutes before',
    fifteenMinutesBefore: '15 minutes before',
    thirtyMinutesBefore: '30 minutes before',
    fourtyFiveMinutesBefore: '45 minutes before',
    oneHourBefore: '1 hour before',
    fiveMinutes: '5 minutes',
    tenMinutes: '10 minutes',
    fifteenMinutes: '15 minutes',
    thirtyMinutes: '30 minutes',
    fourtyFiveMinutes: '45 minutes',
    oneHour: '1 hour',
    language: 'Language',
    bs: 'Bosnian',
    de: 'German',
    en: 'English',
    es: 'Spanish',
    fr: 'French',
    sr: 'Serbian',
    this: 'This',
    is: 'is',
    near: 'near',
    /**
     * Notifications
     */
    today: 'Today',
    clear: 'Clear',
    noNewNotifications: 'No New Notifications',
    noNewNotificationsHint: "You're all caught up! Check back later for new notifications.",
    /**
     * Validator App
     */
    /**
     * Login screen
     */
    welcome: 'Welcome',
    scanQrCodeHint: 'Use the QR code shown in your organizer dashboard to login.',
    scanQrCode: 'Scan QR code',
    switchedEnvironment: 'Switched Environment',
    switchedEnvironmentToProd: 'Switched environment to prod',
    switchedEnvironmentToDev: 'Switched environment to dev',
    appVersion: 'App Version',
    /**
     * Login-Scan screen
     */
    qrCodeScannerHint: 'Please scan the organizer QR code to login.',
    loginQrErrorTitle: 'Login failed.',
    loginQrError: 'Please use the correct organiser QR code from the admin dashboard.',
    loginLoading: "Almost done. Please don't exit the application until information is loaded.",
    /**
     * Ticket-Scan screen
     */
    tapToStartScanning: 'Tap to start scanning',
    validTicket: 'Check-In successful!',
    invalidTicket: 'Invalid Ticket!',
    scannedAt: 'Scanned at',
    venueInfoError: 'Unable to fetch venue information',
    signingKeyError: 'Unable to fetch signing key',
    eventInfoError: 'Unable to fetch event information',
    ticketQrError: 'Unable to scan QR-Code',
    scanTickets: 'Scan Tickets',
    ticketCountError: 'Unable to fetch amount of scanned tickets',
    scanAgain: 'Scan again',
    signOutTitle: 'Are you sure you want to Sign Out?',
    signOutText: 'Make sure you saved all the changes you made before signing out.',
    logout: 'Logout',
    checkedIn: 'Checked-in:',
    of: 'of',
    validatingTicket: 'Validating ticket.',
};
//# sourceMappingURL=en.js.map